// components/index.ts
import dynamic from "next/dynamic";

const RemixGalleryLayout = dynamic(() => import("./RemixGalleryLayout"), { ssr: false });
const FluxPlaygroundRemix = dynamic(() => import("./FluxPlaygroundRemix"), { ssr: false })
const ImageMaskingTool = dynamic(() => import("./ImageMaskingTool"), { ssr: false })
export { default as Generator } from "./Generator";
export { default as Header } from "./Header";
export { default as ClientOnly } from "./ClientOnly";
export { default as ConsentModal } from "./ConsentModal";
export { default as Dropzone } from "./Dropzone";
export { default as FilterOption } from "./FilterOption";
export { default as Footer } from "./Footer";
export { default as GoogleForm } from "./GoogleForm";
export { default as InputWithDebounce } from "./InputWithDebounce";
export { default as Jumbotron } from "./Jumbotron";
export { default as LayoutWrapper } from "./LayoutWrapper";
export { default as ModelCard } from "./ModelCard";
export { default as ModelsCreationsLayout } from "./ModelsCreationsLayout";
export { default as Navbar } from "./Navbar";
export { default as NsfwImage } from "./NsfwImage";
export { default as PageTracker } from "./PageTracker";
export { default as PrivateComponent } from "./PrivateComponent";
export { default as PromptExample } from "./PromptExample";
export { default as PromptModal } from "./PromptModal";
export { RemixGalleryLayout, FluxPlaygroundRemix,  ImageMaskingTool};
export { default as ResponsiveStack } from "./ResponsiveStack";
export { default as ScrollToTop } from "./ScrollToTop";
export { default as SimpleTable } from "./SimpleTable";
export { default as SkeletonCard } from "./SkeletonCard";
// src/components/index.ts
export { default as Header_nsfw } from "./Header_nsfw/Header_nsfw";

// src/components/index.ts

export { default as ImageSection } from './ImageSection';
export { default as DeepModeFeatures } from './DeepModeFeatures';
export { default as Header_home } from "./Header_home/Header_home";
export { default as ImageSectionhome } from './ImageSectionhome';
export { default as Navbarforhome } from "./Navbarforhome";
export { default as FluxPlayground } from "./FluxPlayground";
export { default as ModelGenerationsDisplay } from "./ModelGenerationsDisplay";
export { default as FluxPlaygroundNormal } from "./FluxPlaygroundNormal";
export { default as MaskingTool } from "./MaskingTool";
export { default as AsyncDisplay } from "./AsyncDisplay";
export { default as PromptTooltip } from "./PromptTooltip"
export { default as ImageViewerModal } from "./ImageViewerModal"
export { default as CustomRatioModal } from "./CustomRatioModal"